export const nvpTokens = {
  color: {
    primary: {
      deepBackground: "#0B0F2A",
      electricBlue: "#37D5FF",
      neonPink: "#FF4FD8",
      brightYellow: "#FFD84D",
      cosmicViolet: "#9B5CFF",
      matrixGreen: "#32F38B"
    },
    semantic: {
      success: "#32F38B",
      warning: "#FFD84D",
      danger: "#FF4F6E",
      info: "#37D5FF"
    },
    surface: {
      base: "#000000",
      sunken: "#080B1E",
      elevated: "#10172F",
      glass: "rgba(16, 23, 47, 0.68)",
      glassStrong: "rgba(12, 16, 38, 0.86)"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.78)",
      muted: "rgba(255, 255, 255, 0.62)"
    }
  },
  gradient: {
    cosmic:
      "radial-gradient(circle at 22% 18%, rgba(55, 213, 255, 0.26), transparent 31%), radial-gradient(circle at 76% 16%, rgba(255, 79, 216, 0.30), transparent 33%), linear-gradient(180deg, #000000 0%, #000000 100%)",
    gameCard:
      "linear-gradient(135deg, rgba(55, 213, 255, 0.20) 0%, rgba(155, 92, 255, 0.18) 44%, rgba(255, 79, 216, 0.20) 100%)",
    cta:
      "linear-gradient(135deg, rgba(255, 79, 216, 0.92) 0%, rgba(155, 92, 255, 0.92) 48%, rgba(255, 216, 77, 0.96) 100%)",
    edge:
      "linear-gradient(90deg, transparent 0%, rgba(55, 213, 255, 0.88) 18%, rgba(255, 79, 216, 0.9) 55%, rgba(255, 216, 77, 0.9) 82%, transparent 100%)"
  },
  glow: {
    blue: "0 0 34px rgba(55, 213, 255, 0.42)",
    pink: "0 0 34px rgba(255, 79, 216, 0.44)",
    yellow: "0 0 34px rgba(255, 216, 77, 0.42)",
    violet: "0 0 34px rgba(155, 92, 255, 0.42)",
    green: "0 0 34px rgba(50, 243, 139, 0.34)"
  },
  radius: {
    card: "8px",
    control: "8px",
    pill: "999px"
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
    "3xl": "72px"
  },
  typography: {
    hero: {
      fontSize: "clamp(4rem, 10vw, 8rem)",
      lineHeight: "0.88",
      letterSpacing: "0"
    },
    sectionTitle: {
      fontSize: "clamp(2rem, 5vw, 4rem)",
      lineHeight: "1",
      letterSpacing: "0"
    },
    cardTitle: {
      fontSize: "1.5rem",
      lineHeight: "1.1",
      letterSpacing: "0"
    },
    body: {
      fontSize: "1rem",
      lineHeight: "1.7"
    },
    caption: {
      fontSize: "0.78rem",
      lineHeight: "1.3",
      letterSpacing: "0.08em"
    }
  },
  motion: {
    duration: {
      fast: "140ms",
      medium: "240ms",
      slow: "520ms"
    },
    easing: {
      standard: "cubic-bezier(0.22, 1, 0.36, 1)",
      punch: "cubic-bezier(0.16, 1, 0.3, 1)",
      inOut: "cubic-bezier(0.65, 0, 0.35, 1)"
    }
  },
  layout: {
    container: "1180px",
    wideContainer: "1440px",
    desktopColumns: 12
  },
  brand: {
    logo: {
      dieMarkSize: {
        base: "36px",
        md: "42px"
      },
      wordmarkWidth: {
        base: "92px",
        md: "104px"
      },
      wordmarkHeight: {
        base: "50px",
        md: "56px"
      },
      white: "#FFFFFF",
      pink: "#FF44DF",
      yellow: "#FFD42C",
      shadow: "0 0 10px rgba(255, 79, 216, 0.22)",
      starCutout: "#050611",
      gamesFill: "rgba(255, 255, 255, 0.78)"
    }
  },
  landing: {
    header: {
      scrollThresholdPx: 12,
      studioActivationOffsetPx: 150,
      background: "rgba(0, 0, 0, 0.18)",
      scrolledBackground:
        "linear-gradient(180deg, rgba(5, 6, 18, 0.92), rgba(7, 7, 24, 0.72))",
      scrolledBorder: "rgba(255, 79, 216, 0.22)",
      scrolledShadow: "0 0 34px rgba(55, 213, 255, 0.12)",
      backdropFilter: "blur(16px) saturate(1.2)",
      edgeOpacity: 0.28
    },
    hero: {
      backgroundAspectRatio: "3740 / 1682",
      backgroundFitWidthHeight: "calc(100vw * 1682 / 3740)",
      viewportMinHeight: "100svh",
      backgroundFadeMask:
        "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 14%, #000 86%, rgba(0, 0, 0, 0) 100%)",
      scrim:
        "linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 12%, rgba(0, 0, 0, 0) 88%, #000000 100%)",
      container: "1440px",
      contentMaxWidth: {
        base: "520px",
        md: "560px",
        lg: "700px"
      },
      titleFontSize: {
        base: "3.6rem",
        md: "5.7rem",
        lg: "5.15rem"
      },
      titleLineHeight: 0.9,
      minHeight: {
        base: "560px",
        md: "720px",
        lg: "760px"
      },
      paddingTop: {
        base: "96px",
        md: "148px"
      },
      paddingBottom: {
        base: "40px",
        md: "56px"
      },
      contentPaddingX: {
        base: "24px",
        md: "24px",
        xl: "32px"
      },
      textPanel: {
        background: "rgba(0, 0, 0, 0.46)",
        border: "rgba(255, 255, 255, 0.12)",
        shadow: "0 18px 44px rgba(0, 0, 0, 0.28)",
        backdropFilter: "blur(5px)"
      }
    },
    featured: {
      minHeight: {
        base: "500px",
        md: "420px",
        lg: "430px"
      },
      contentPadding: {
        base: "24px",
        md: "40px",
        lg: "56px"
      },
      contentMaxWidth: {
        base: "100%",
        md: "540px",
        lg: "610px"
      },
      titleFontSize: {
        base: "2.55rem",
        md: "3.6rem",
        lg: "4.35rem"
      },
      titleLineHeight: 0.95,
      logoWidth: {
        base: "86%",
        md: "48%",
        lg: "46%"
      }
    }
  }
} as const;

export type PrimitiveTone = "blue" | "pink" | "yellow" | "violet" | "green";
